import { createAsyncThunk } from '@reduxjs/toolkit'
import { debouncedGetSuggestsQueryByCoords } from 'feature/DaData/getSuggestsQueryByCoords'
import { RootState } from 'store/types'

// получить экземпляр предполагаемого адреса по координатам клика по карте
export const getSuggestsQueryByMapClick = createAsyncThunk<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  [number, number],
  { state: RootState }
>('address/getSuggestsQueryByMapClick', async clickedCoords => {
  const response = await debouncedGetSuggestsQueryByCoords(
    String(clickedCoords[0]),
    String(clickedCoords[1]),
  )

  return response
})
